import { render, staticRenderFns } from "./editorial-board.vue?vue&type=template&id=29d893df&scoped=true"
import script from "./editorial-board.vue?vue&type=script&lang=js"
export * from "./editorial-board.vue?vue&type=script&lang=js"
import style0 from "./editorial-board.vue?vue&type=style&index=0&id=29d893df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8c4e5e0a3a88c7932152ef02627e3518/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d893df",
  null
  
)

export default component.exports